import { render } from "./BoardModalEdit.vue?vue&type=template&id=25031545&scoped=true"
import script from "./BoardModalEdit.vue?vue&type=script&lang=js"
export * from "./BoardModalEdit.vue?vue&type=script&lang=js"

import "./BoardModalEdit.vue?vue&type=style&index=0&id=25031545&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-25031545"

export default script